import { ErrorMessage } from "formik";
import { Col,Row, Form } from "react-bootstrap";

const TextInput = ({
    label,
    name,
    value,
    onChange,
    onBlur,
    required,
    errors,
    disabled = false,
    type,
    as,
    asRow="Row",
    min,
    max
  }) => (
    <Form.Group as={asRow === "Col" ? Col : Row} className="form-group">
      <Form.Label htmlFor={name} column sm="4" className="control-label align-self-center mb-0">
        {label}
        {required && <span className="text-danger">*</span>}
      </Form.Label>
      <Col sm="8">
        <Form.Control
          type={type || "text"}
          name={name}
          placeholder={`Enter ${label.toLowerCase()}`}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          as={as}
          min={min}
          max={max}
          style={as === "textarea" ? { resize: "none", height: "150px" } : {}}
        />
        <ErrorMessage name={name} component="div" className="text-danger" />
        {Array.isArray(errors) &&
          errors.map((error, index) => (
            <span key={index} className="w-100 mt-1 small text-danger">
              {error}
              <br />
            </span>
          ))}
      </Col>
    </Form.Group>
  );

  export default TextInput;